export default "__VITE_ASSET__0393ff04__"